module.exports = __webpack_public_path__ + "static/media/snapscope-logo.e2f513aa.jpg";